<template>
  <v-navigation-drawer dark absolute expand-on-hover permanent right>
    <v-list dense>
      <v-list-item @click="loadSummary()">
        <v-list-item-icon>
          <v-icon>mdi-poll</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Summary</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list-item @click="loadPresentation()">
        <v-list-item-icon>
          <v-icon>mdi-poll</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Presentation</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "ResultsPropositionBar",
  props: {
    doc: {
      type: Object,
    },
    includeAdmin: Boolean,
  },
  computed: {
    filteredUsers() {
      if (this.includeAdmin) {
        return this.doc.users;
      } else {
        return this.doc
          ? this.doc.users.filter((item) => item.webrole == "user")
          : null;
      }
    },
    ...mapState(["currentUser"]),
  },
  methods: {
    loadUser(val) {
      this.$emit("loadUser", val);
    },
    loadSummary() {
      this.$emit("loadSummary", "summary");
    },
    loadPresentation() {
      this.$emit("loadSummary", "presentation");
    },
  },
};
</script>
